var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1319 8.34422L4.98241 1.19477H15.8971C16.2706 1.19477 16.5396 1.35913 16.7039 1.68784C16.8683 2.01655 16.8384 2.33032 16.6143 2.62915L12.1319 8.34422ZM11.4147 12.6922V14.642C11.4147 14.896 11.3288 15.1089 11.1569 15.2808C10.9851 15.4526 10.7722 15.5385 10.5182 15.5385H8.72523C8.47122 15.5385 8.25831 15.4526 8.08648 15.2808C7.91466 15.1089 7.82875 14.896 7.82875 14.642V9.10623L0.746533 2.02402C0.582178 1.85967 0.5 1.65422 0.5 1.40769C0.5 1.16116 0.582178 0.948241 0.746533 0.768945C0.925829 0.589648 1.13874 0.5 1.38528 0.5C1.63181 0.5 1.84472 0.589648 2.02402 0.768945L17.2418 15.9867C17.4211 16.166 17.507 16.3752 17.4996 16.6143C17.4921 16.8533 17.3987 17.0625 17.2194 17.2418C17.0401 17.4062 16.8309 17.4921 16.5919 17.4996C16.3528 17.507 16.1436 17.4211 15.9643 17.2418L11.4147 12.6922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconButton);
export default __webpack_public_path__ + "static/media/filter_icon_button.df8508498669036ff70c1ec4ec7e1306.svg";
export { ForwardRef as ReactComponent };